import { render, staticRenderFns } from "./tag-op-log-modal.vue?vue&type=template&id=ef84ff50&scoped=true&"
import script from "./tag-op-log-modal.vue?vue&type=script&lang=js&"
export * from "./tag-op-log-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef84ff50",
  null
  
)

export default component.exports